import type { Bundle } from "@otto/lehrgang";
import { cssVar } from "../../../shared/lib/cssVar.js";
import { legendEntries } from "../lib/legendEntries.js";
import styles from "./FingerLegend.module.css";

/**
 * Fingerfarben unten auf jedem Bildschirm – wie im Prototyp.
 *
 * Die Finger stehen so im Bundle; zusammengefasst wird nur noch nach Farbe,
 * damit dort „Mittelfinger“ steht und nicht zweimal derselbe Punkt mit Seite.
 * Vor dem Umdrehen des Modells musste `legendEntries` die Finger erst aus
 * Tastenzeilen zurückrechnen – das ist weg, das Zusammenfassen geblieben.
 */
export function FingerLegend({ bundle }: { bundle: Bundle }) {
  return (
    <footer className={styles.legend}>
      {legendEntries(bundle.fingers).map((entry) => (
        <span key={entry.color} className={styles.legendItem}>
          <span
            className={styles.legendDot}
            style={cssVar({ background: entry.color })}
          />{" "}
          {entry.name}
        </span>
      ))}
    </footer>
  );
}
